export default __webpack_public_path__ + "static/media/PortfolioDp.66e64500.jpeg";